import React, { useContext, useState, useEffect } from 'react'
import { Row, Col, Spinner } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { MigrantContext } from '../../../contexts/migrantContext'
import { updateConsumer } from '../../../services/migrantService'
import { StoreKey } from '../../../config/enums'
import { toast } from 'react-toastify'
import { friendlyMessageFor } from '../../../utility/errorHelper'
import { getFilteredCountries } from '../../../services/countryService'
import constants from '../../../config/constants'
import CountryRow from './countryRow'
import Layout from '../../common/layout/layout'
import { Country } from '../../../models/Country'

function WorkCountry() {
  const history = useHistory()
  const migrantContext = useContext(MigrantContext)
  const [countryList, setCountryList] = useState<Country[]>([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    getFilteredCountries(constants.workCountries).then(countries => {
      setCountryList(countries)
    })
  }, [])

  const updateHomeAndWorkCountry = (workCountryId: string) => {
    setIsLoading(true)
    var homeCountryId = localStorage.getItem(StoreKey.homeCountry)
    updateConsumer(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      homeCountryId!,
      workCountryId
    )
      .then(updatedProfile => {
        if (updatedProfile) {
          migrantContext?.setProfile(updatedProfile)
          localStorage.removeItem(StoreKey.homeCountry)
        } else {
          toast.warn(friendlyMessageFor(''))
        }
      })
      .then(() => {
        history.push('/')
      })
      .catch(err => {
        toast.error(friendlyMessageFor(err))
        setIsLoading(false)
      })
  }

  return (
    <Layout>
      <Row>
        <Col xl={8} className="mx-auto">
          <Row>
            <Col xs={12}>
              <h1 className="pageTitle">Work Country</h1>
              <p className="pageSubtitle">Where do you currently work?</p>
            </Col>
          </Row>
          <Row className="mt-3">
            {countryList.map(country => {
              return (
                <CountryRow
                  key={country.id}
                  country={country}
                  onSelectRow={countryId => {
                    if (!isLoading) {
                      updateHomeAndWorkCountry(countryId)
                    }
                  }}
                />
              )
            })}
          </Row>
          {isLoading && (
            <Row className="mt-4">
              <Col className="text-center">
                <span className="mr-2">
                  <Spinner animation="border" size="sm" />
                </span>
                Saving...
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    </Layout>
  )
}

export default WorkCountry
